import React from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'
import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import ModalAddMaestra from '../components/Maestra/ModalAddMaestra'
import ModalProgress from '../components/Maestra/ModalProgress'
import ModalDelete from '../components/Shared/ModalDelete'
import store from '../utils/store'

import FontAwesome from 'react-fontawesome'

import {
    getMaestras,
    toggleSelectAllItems,
    toggleSelectItem,
    showHideModalAddMaestra,
    deleteMaestras,
    getProveedores,
    synchroUsers,
    getItems,
    getCencos
} from '../actions/maestra'
import { getParameterByName, showHideModalDelete } from '../actions/common';

const tableCols = [
    { Id: 1, Caption: "Nombre Maestra", Value: "nombre", Type: "string", Width: "10" },
    { Id: 2, Caption: "Fecha de actualización", Value: "updated_at", Type: "datetime", Width: "10", Format: 'YYYY-MM-DD' },
]

function findValues(c, x) {
    let value = x.getIn(c.Value.split('.'))

    return value
}

class Maestra extends React.Component {
    componentWillMount() {
        this.props.getMaestras()
        this.props.getParameterByName('MAESTRAS')
    }

    handleAction = (row) => {
        console.log();
        switch (row.get('nombre')) {
            case "Proveedores":
                this.props.getProveedores()
                break;
            case "Usuarios":
                this.props.synchroUsers()
                break;
            default:
                break;
        }
    }

    render() {
        const { maestras, enums } = this.props
        const boxActions = [
            <BoxButton key="ba[0]" name="plus-circle" onClick={e => this.props.showHideModalAddMaestra(true, 'Creación de Maestras', 'create')} title="Nueva Maestra" />,
            <BoxButton key="ba[1]" name="trash" onClick={e => this.props.showHideModalDelete(true, `Esta seguro que desea eliminar los Maestras seleccionadas?`, () => this.props.deleteMaestras())} disabled={maestras.filter(x => x.get('checked')).count() === 0} danger title="Eliminar maestra" />,
        ]

        return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Maestras" stretch>

                        <ButtonStrip actions={boxActions} />

                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>

                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-maestras">
                                <thead>
                                    <tr>
                                        <th width="20px">
                                            <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={e => this.props.toggleSelectAllItems(e.target.checked)} checked={maestras.filter(x => x.get('checked')).count() > 0 && maestras.filter(x => x.get('checked')).count() || false} />
                                        </th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.Width}` }
                                                return (
                                                    <th key={`th1[${x.Id}]`} style={style}>{x.Caption}</th>
                                                )
                                            })
                                        }
                                        <th width="100px" style={{ textAlign: 'center' }}>Sincronizar</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr>
                                        <td><input type="checkbox" style={{ verticalAlign: 'middle' }} disabled /></td>
                                        <td>items</td>
                                        <td style={{ textAlign: 'right' }}>{moment().format('YYYY-MM-DD')}</td>
                                        <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '7px' }}>
                                            <button onClick={() => this.props.getItems()}>
                                                <FontAwesome name="check" />
                                            </button>
                                        </td>
                                    </tr>



                                    <tr>
                                        <td><input type="checkbox" style={{ verticalAlign: 'middle' }} disabled /></td>
                                        <td>cencos</td>
                                        <td style={{ textAlign: 'right' }}>{moment().format('YYYY-MM-DD')}</td>
                                        <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '7px' }}>
                                            <button onClick={() => this.props.getCencos()}>
                                                <FontAwesome name="check" />
                                            </button>
                                        </td>
                                    </tr>


                                    {
                                        maestras.map((x, c) => {
                                            return (
                                                <tr key={`tr1[${x.get('id')}]`} className={x.get('checked') ? 'info' : ''}>
                                                    <td>
                                                        <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={e => this.props.toggleSelectItem(c, e.target.checked)} checked={x.get('checked') || false} />
                                                    </td>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)

                                                            if (c.Type) {
                                                                switch (c.Type) {
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.Format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'html':
                                                                        value = <div style={{ maxHeight: '10vh', overflowX: 'hidden' }} dangerouslySetInnerHTML={{ __html: value }} />
                                                                        break
                                                                    case 'datetime':
                                                                        value = value ? moment(value).format(c.Format) : '';
                                                                        alignment = 'right';
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={`td1[${x.get('id')}][${c.Id}]`} className='LinkToEdit' style={style} onClick={e => this.props.showHideModalAddMaestra(true, 'Modificación de maestras', 'edit', x.get('id'))}>{value}</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={`td1[${x.get('id')}][${c.Id}]`} style={style}>{value}</td>
                                                                )
                                                            }
                                                        })
                                                    }

                                                    <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '7px' }}>
                                                        <button onClick={() => this.handleAction(x)}>
                                                            <FontAwesome name="check" />
                                                        </button>                                                        
                                                    </td>                                                    
                                                </tr>
                                            )
                                        })
                                    }



                                    

                                </tbody>
                            </table>                       
                        
                        </div>                
                    
                    </Box>
                </div>

                <ModalAddMaestra />
                <ModalDelete />
                <ModalProgress />

                


            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        maestras: state.maestras.get('maestras'),
        enums: state.common.get('enums').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getMaestras: (page) => dispatch(getMaestras(page)),
        toggleSelectItem: (index, checked) => dispatch(toggleSelectItem(index, checked)),
        toggleSelectAllItems: (checked) => dispatch(toggleSelectAllItems(checked)),
        showHideModalAddMaestra: (show) => dispatch(showHideModalAddMaestra(show)),
        showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
        deleteMaestras: () => dispatch(deleteMaestras()),
        getParameterByName: (param) => dispatch(getParameterByName(param)),
        getProveedores: () => dispatch(getProveedores()),
        synchroUsers: () => dispatch(synchroUsers()),
        getItems: () => dispatch(getItems()),
        getCencos: () => dispatch(getCencos()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Maestra)


// WEBPACK FOOTER //
// ./src/containers/Maestra.jsx